import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "../../../../../animations/worldcup/table";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
import Image from "../../../../shared/components/Image";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import i18n from "i18next";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import { findRankStatusChangesV2 } from "../../../../shared/functions/standing";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const matchInfo = _.get(dynamic, "matchInfo");
  const standing = _.get(dynamic, "standing");
  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));
  const homeTeam = matchInfo?.TeamStatistic?.[0];
  const awayTeam = matchInfo?.TeamStatistic?.[1];

  const teamSide = getContentById("selectedSide", fields);
  let targetTeamId = teamSide === "home" ? homeTeam?.TeamId : awayTeam?.TeamId;
  if (!targetTeamId) {
    // const event = _.get(data, "event");
    targetTeamId = 'DFL-CLU-J00001'; // Germany by default
  }
  const findGroup = _.find(standing, (group) => {
    const isGroupStage = group?.Group?.includes('GROUP');
    const hasTeam = _.some(group?.Entry, { ClubId: targetTeamId });

    return isGroupStage && hasTeam;
  });
  const competitionId = matchInfo?.competition?.id;
  const lng = i18n?.language;
  const linesMarkersByRankType = findRankStatusChangesV2(
    findGroup?.Entry || [],
    [],
  );

  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />
        {/*<WcBgCircle />*/}
        <div
          className={`wc-content wc-content-v2 wc-standing-container competition-${competitionId}`}
        >
          <ProgressBar height={"8px"} strokeColor="#177C76" />
          <div className="wc-standing-header">
            <div className={"competition-positioner"}>
              <div className={"competition-logo-container"}>
                <Image
                  src={`/images/dynamic/soccer/competition/fifa-2026-worldcup.svg`}
                />
              </div>
              <div className="second-title">
                {dynamic?.matchInfo?.week &&
                  (lng === "de" ? (
                    <span>
                      {dynamic.matchInfo.week}. {t("Matchday")}{" "}
                    </span>
                  ) : (
                    <span>
                      {t("Matchday")} {dynamic.matchInfo.week}
                    </span>
                  ))}

                {!dynamic?.matchInfo?.week &&
                  dynamic?.matchInfo?.stage?.name && (
                    <span>{t(dynamic.matchInfo.stage?.name)}</span>
                  )}
              </div>
            </div>
            <div className="main-title">
              {_.includes(_.lowerCase(findGroup?.stageName), "stage")
                ? null
                : findGroup?.stageName
                  ? findGroup?.stageName?.replace(
                    "League",
                    `${t("League", { keyPrefix: "templates" })}`,
                  ) + " - "
                  : ""}
              {/* {findGroup?.groupName?.replace(
                "Group",
                t("Group", { keyPrefix: "templates" }),
              )} */}
              {t("Standings", { keyPrefix: "templates" })} - {findGroup?.Group?.replace(
                /GROUP\s?/,
                `${t("Group", { keyPrefix: "templates" })} `
              )}
            </div>
          </div>

          <div className={"group-table"}>
            {/*<div className={'group-label green-glow'}>{findGroup?.groupName?.replace('Group', t("Group", {keyPrefix: 'templates'}))}</div>*/}
            <div className={"group-content"}>
              <div className={"table-head"}>
                <div className={"col-pos col"}></div>
                <div className={"col-team col"}></div>
                <div className={"col-points col"}>
                  {t("PL", { keyPrefix: "table" })}
                </div>
                <div className={"col-points col"}>
                  {t("W", { keyPrefix: "table" })}
                </div>
                <div className={"col-points col"}>
                  {t("D", { keyPrefix: "table" })}
                </div>
                <div className={"col-points col"}>
                  {t("L", { keyPrefix: "table" })}
                </div>
                <div className={"col-diff col"}>
                  {t("GD", { keyPrefix: "table" })}
                </div>
                <div className={"col-pkt col"}>
                  {t("PTS", { keyPrefix: "table" })}
                </div>
              </div>
              {findGroup?.Entry?.map((entry, index) => {
                const greenMarkIndex = _.findLast(linesMarkersByRankType, {
                  relegation: false,
                })?.rowIndex;

                const properIndex = index;
                const markRowIndex = _.findIndex(linesMarkersByRankType, {
                  rowIndex: properIndex + 1,
                  relegation: false,
                });

                const isMarked =
                  markRowIndex > -1 &&
                  linesMarkersByRankType?.[markRowIndex]?.rowIndex ===
                  properIndex + 1;

                return (
                  <div
                    key={"table-" + index}
                    className={`table-row ${isMarked ? "mark-row" : ""}`}
                  >
                    <div className={"col-pos col"}>{++index}.</div>
                    <div className={"col-team col"}>
                      <div className={"col-logo"}>
                        {/*<img className="team-logo" src={`/images/countries/svg/${getOptaCountryCode(entry?.contestantName, entry?.contestantShortName, entry?.contestantCode)}.svg`}/>*/}
                        {/*<Image className="team-logo" src={`/images/countries/svg/${getOptaCountryCode(entry?.contestantName, entry?.contestantShortName, entry?.contestantCode)}.svg`}/>*/}
                        <Image
                          className="team-logo"
                          src={getDynamicLogoPath({
                            team: {
                              TeamId: entry?.ClubId,
                              TeamName: entry?.Club,
                              ThreeLetterCode: entry?.ThreeLetterCode
                            },
                            competitionId,
                          })}
                        />
                      </div>
                      {t(entry?.Club || entry?.ShortName, {
                        ns: "countries",
                      }) || entry?.contestantName}
                    </div>
                    <div className={"col-points col"}>
                      {entry.GamesPlayed}
                    </div>
                    <div className={"col-points col"}>{entry.Wins}</div>
                    <div className={"col-points col"}>{entry.Draws}</div>
                    <div className={"col-points col"}>{entry.Losses}</div>
                    <div className={"col-diff col"}>{entry.GoalsDifference}</div>
                    <div className={"col-pkt col"}>{entry.Points}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `sd_background_1920`);
};

export default Index;
